import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TeamUserCard from "../../components/Cards/TeamUserCard";
import { MenuBar } from "../../components/Menu/Menu";
import { choose_image } from "../../components/Transformation/Transformations"
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader/Loader";
import { getTeamMembers } from "../../store/actions/user.action";


function OurTeam() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);

  const { teamMembers, teamMembersLoading, teamMembersError } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    dispatch(getTeamMembers());
  }, [dispatch]);

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  const getSectionLabel = (order) => {
    switch (order) {
      case 40:
        return "🏛 Leadership";
      case 30:
        return "Vice Presidents";
      case 20:
        return "Directors";
      case 10:
        return "🌍 Regional Directors";
      case 0:
        return "🎓 Alumni & Former Members";
      default:
        return "Team Members";
    }
  };

  const membersByOrder = teamMembers.reduce((acc, member) => {
    const order = member.teammember_order ?? 10;
    if (!acc[order]) {
      acc[order] = [];
    }
    acc[order].push(member);
    return acc;
  }, {});

  const sections = Object.keys(membersByOrder)
    .map(Number)
    .sort((a, b) => b - a)
    .map((order) => ({
      order,
      label: getSectionLabel(order),
      members: membersByOrder[order],
    }));

  return (
    <div>
      <Header openMenu={openMenuBar} />

      {/* Hero */}
      <div className="bg-gradient-to-br from-[#1A1A2E] to-[#2D2D60] text-white py-16 text-center">
        <div className="max-w-[1120px] mx-auto px-6">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold mb-4">
            {t("team.our_team")}
          </h1>
          <p className="opacity-70 max-w-lg mx-auto">
            A passionate group of students and educators working to make language learning accessible worldwide.
          </p>
        </div>
      </div>

      <div className="max-w-[1120px] mx-auto px-6 py-20">
        {teamMembersLoading ? (
          <div className="flex justify-center items-center min-h-[400px]">
            <Loader />
          </div>
        ) : teamMembersError ? (
          <div className="flex justify-center items-center min-h-[400px]">
            <div className="text-red-600 text-xl">{teamMembersError}</div>
          </div>
        ) : (
          <>
            {sections.map((section) => (
              <div key={section.order} className="mb-12">
                <h3 className="text-xl font-bold mb-7 pb-3 border-b-2 border-[var(--border)]">
                  {section.label}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.members.map((member) => (
                    <TeamUserCard
                      key={member.id}
                      name={`${member.first_name} ${member.last_name}`}
                      image={member.image || choose_image("generic.nobody")}
                      job={member.teammember_title}
                      summary={member.teammember_introduction}
                    />
                  ))}
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Join Banner */}
      <div className="bg-gradient-to-br from-[#6C63FF] to-[#4B44CC] text-white">
        <div className="max-w-[1120px] mx-auto px-6 py-16 text-center">
          <div className="text-3xl mb-4">🤝</div>
          <h2 className="text-2xl md:text-3xl font-extrabold mb-3">{t("redesign.team_join_title")}</h2>
          <p className="opacity-75 max-w-lg mx-auto mb-7">{t("redesign.team_join_desc")}</p>
          <a href="mailto:support@lingoclub.org?subject=Join Lingo Club Team" className="inline-flex items-center px-7 py-3 rounded-full bg-white text-[var(--brand)] font-bold hover:-translate-y-[1px] transition-all">
            Get In Touch →
          </a>
        </div>
      </div>

      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
}

export default OurTeam;
